import React, { useState } from 'react';
import { Typography, Breadcrumb, Card, Form, Input, Switch, Select, Button, Space, message } from 'antd';

const { Title, Paragraph } = Typography;

const SecurityLogin = () => {
  const [form] = Form.useForm();
  const [saving, setSaving] = useState(false);

  const onSave = async () => {
    try {
      await form.validateFields();
      setSaving(true);
      await new Promise(r => setTimeout(r, 400));
      message.success('Security settings saved');
    } finally {
      setSaving(false);
    }
  };

  const onChangePassword = async () => {
    try {
      const values = await form.validateFields(['currentPassword', 'newPassword', 'confirmPassword']);
      if (values.newPassword !== values.confirmPassword) {
        return message.error('New password and confirmation do not match');
      }
      await new Promise(r => setTimeout(r, 400));
      message.success('Password changed');
      form.resetFields(['currentPassword', 'newPassword', 'confirmPassword']);
    } catch (_) {
      // ignore validation errors
    }
  };

  return (
    <div style={{ padding: 24 }}>
      <Breadcrumb items={[{ title: 'Client' }, { title: 'Settings' }, { title: 'Security & Login' }]} />
      <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginTop: 12, marginBottom: 16 }}>
        <Title level={3} style={{ margin: 0 }}>Security & Login</Title>
        <Space>
          <Button type="primary" onClick={onSave} loading={saving}>Save</Button>
        </Space>
      </div>

      <Card style={{ marginBottom: 16 }}>
        <Paragraph type="secondary">Authentication preferences</Paragraph>
        <Form form={form} layout="vertical" initialValues={{ enforce2FA: false, default2FAMethod: 'app' }}>
          <Form.Item label="Enforce 2FA" name="enforce2FA" valuePropName="checked">
            <Switch />
          </Form.Item>
          <Form.Item label="Default 2FA Method" name="default2FAMethod">
            <Select style={{ width: 240 }}>
              <Select.Option value="app">Authenticator App</Select.Option>
              <Select.Option value="sms">SMS</Select.Option>
              <Select.Option value="email">Email</Select.Option>
            </Select>
          </Form.Item>
        </Form>
      </Card>

      <Card>
        <Paragraph type="secondary">Change password</Paragraph>
        <Form form={form} layout="vertical">
          <Form.Item label="Current Password" name="currentPassword" rules={[{ required: true }]}>
            <Input.Password placeholder="Enter current password" />
          </Form.Item>
          <Form.Item label="New Password" name="newPassword" rules={[{ required: true, min: 8 }]}>
            <Input.Password placeholder="At least 8 characters" />
          </Form.Item>
          <Form.Item label="Confirm New Password" name="confirmPassword" rules={[{ required: true }]}>
            <Input.Password placeholder="Re-enter new password" />
          </Form.Item>
          <Button onClick={onChangePassword}>Change Password</Button>
        </Form>
      </Card>
    </div>
  );
};

export default SecurityLogin;
